import { render, staticRenderFns } from "./Perfiles.vue?vue&type=template&id=67ab0212&scoped=true&"
import script from "./Perfiles.vue?vue&type=script&lang=js&"
export * from "./Perfiles.vue?vue&type=script&lang=js&"
import style0 from "./Perfiles.vue?vue&type=style&index=0&id=67ab0212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ab0212",
  null
  
)

export default component.exports